export default "__VITE_ASSET__DYCQ_QMa__"